import { Pipe, PipeTransform } from '@angular/core';
import { RecordProperties } from './record-model';
import { FieldDataType } from '@app/models/module-structure';
import * as moment from 'moment';
import * as g from 'src/app/globals';
import * as accounting from 'accounting';

@Pipe({
  name: 'valueRenderer',
})
export class ValueRendererPipe implements PipeTransform {
  transform(v: unknown, recordProperty: RecordProperties): string {
    const value = recordProperty.ValueAsObject;
    switch (recordProperty.DataType) {
      case FieldDataType.Unkown:
      case FieldDataType.Attachment:
      case FieldDataType.Hidden:
      case FieldDataType.Label:
      case FieldDataType.Address:
      case FieldDataType.String:
      case FieldDataType.Link:
      case FieldDataType.Text:
        case FieldDataType.HTMLEditor:
        return value;
      case FieldDataType.Number:
        return accounting.formatNumber(
          value,
          g.companyConfiguration.PriceDecimal,
          g.companyConfiguration.ThousandSep,
          g.companyConfiguration.DecimalSep
        );
      case FieldDataType.Select:
        return recordProperty.Options.find(
          (o) => o.Code == recordProperty.ValueAsObject
        )?.Name;
      case FieldDataType.Date:
        return recordProperty.ValueAsObject ? moment(recordProperty.ValueAsObject).format(g.companyConfiguration.MomentDateFormat) : '';
      case FieldDataType.Price:
        return accounting.formatNumber(
          value,
          g.companyConfiguration.PriceDecimal,
          g.companyConfiguration.ThousandSep,
          g.companyConfiguration.DecimalSep
        );
      case FieldDataType.Percent:
        return accounting.formatMoney(
          value,
          '%',
          g.companyConfiguration.PercentDecimal,
          '',
          g.companyConfiguration.DecimalSep,
          '%v %s'
        );
      case FieldDataType.Time:
        // Handle time type
        console.log('Data type is Time');
        break;
      case FieldDataType.PriceLocalCurrency:
        // Handle local currency price type
        console.log('Data type is PriceLocalCurrency');
        break;
      case FieldDataType.PriceSystemCurrency:
        // Handle system currency price type
        console.log('Data type is PriceSystemCurrency');
        break;
      case FieldDataType.PriceLines:
        // Handle price lines type
        console.log('Data type is PriceLines');
        break;
      case FieldDataType.PriceFromDocument:
        // Handle price from document type
        console.log('Data type is PriceFromDocument');
        break;
      case FieldDataType.Checkbox:
        return value ? '☑' : '☐';
      case FieldDataType.MultipleDate:
        // Handle multiple date type
        console.log('Data type is MultipleDate');
        break;

      case FieldDataType.CCValidity:
        // Handle credit card validity type
        console.log('Data type is CCValidity');
        break;
      case FieldDataType.Property:
        // Handle property type
        console.log('Data type is Property');
        break;
      case FieldDataType.Amount:
        return accounting.formatNumber(
          value,
          g.companyConfiguration.AmountDecimal,
          g.companyConfiguration.ThousandSep,
          g.companyConfiguration.DecimalSep
        );
      case FieldDataType.AmountFromDocument:
        // Handle amount from document type
        console.log('Data type is AmountFromDocument');
        break;
      case FieldDataType.ItemImage:
        // Handle item image type
        console.log('Data type is ItemImage');
        break;
      case FieldDataType.Quantity:
        return accounting.formatNumber(
          value,
          g.companyConfiguration.QuantityDecimal,
          g.companyConfiguration.ThousandSep,
          g.companyConfiguration.DecimalSep
        );
      case FieldDataType.Title:
        return value;
      case FieldDataType.Signature:
        // Handle signature type
        console.log('Data type is Signature');
        break;
      case FieldDataType.Icon:
        // Handle icon type
        console.log('Data type is Icon');
        break;
      case FieldDataType.Button:
        // Handle button type
        console.log('Data type is Button');
        break;
      case FieldDataType.Map:
        // Handle map type
        console.log('Data type is Map');
        break;
      case FieldDataType.Paragraph:
        // Handle paragraph type
        console.log('Data type is Paragraph');
        break;
      case FieldDataType.Integer:
        return Number(value).toFixed(0).toString();
      case FieldDataType.TimeAmount:
        // Handle time amount type
        console.log('Data type is TimeAmount');
        break;
      case FieldDataType.Rate:
        return accounting.formatNumber(
          value,
          g.companyConfiguration.RateDecimal,
          g.companyConfiguration.ThousandSep,
          g.companyConfiguration.DecimalSep
        );
      default:
        return value;
    }
  }
}
